import React from 'react'
import 'react-widgets/dist/css/react-widgets.css'
import moment from 'moment'
import NLDatePicker from './NLDatePicker'

export default class DateInput extends React.Component {

  constructor(props) {
    super()
    this.state = { open: false }
  }

  componentDidUpdate(oldProps) {
    if (this.props.open !== oldProps.open){
      this.setState({
        open: false,
      })
    }
    
  }

  onChange(e) {
    this.setState({ open: false })
    let date = e ? moment(e).format('YYYY-MM-DD') : null
    this.props.onChange(date)
  }

  open() {
    if (!this.props.disabled) {
      this.setState({ open: 'calendar' })
    }
  }

  render() {
    let value = this.props.value ? moment(this.props.value).toDate() : null
    
    return <NLDatePicker 
            value={value}
            onChange={(e) => this.onChange(e)}

            />
  }
}